import { type App } from 'vue';
import mixpanel from 'mixpanel-browser';

const TOKEN = process.env.VUE_APP_MIXPANEL_TOKEN;

export default {
  install(app: App) {
    mixpanel.init(TOKEN);
    app.provide('mixpanel', mixpanel);
    app.config.globalProperties.$mixpanel = mixpanel;
  },
};
